export const CARDADD_REQUEST = "CARDADD_REQUEST";
export const CARDADD_SUCCESS = "CARDADD_SUCCESS";
export const CARDADD_ERROR = "CARDADD_ERROR";
export const GET_SUBCRIPTION_REQUEST = "GET_SUBCRIPTION_REQUEST";
export const GET_SUBCRIPTION_SUCCESS = "GET_SUBCRIPTION_SUCCESS";
export const GET_SUBCRIPTION_ERROR = "GET_SUBCRIPTION_ERROR";
export const UNSUBCRIPTION_REQUEST = "UNSUBCRIPTION_REQUEST";
export const UNSUBCRIPTION_SUCCESS = "UNSUBCRIPTION_SUCCESS";
export const UNSUBCRIPTION_ERROR = "UNSUBCRIPTION_ERROR";
export const GET_PLAN_REQUEST = "GET_PLAN_REQUEST";
export const GET_PLAN_SUCCESS = "GET_PLAN_SUCCESS";
export const GET_PLAN_ERROR = "GET_PLAN_ERROR";

export const cardAddRequest = (payload) => ({
  type: CARDADD_REQUEST,
  ...payload,
});

export const cardAddSuccess = (subcription) => ({
  type: CARDADD_SUCCESS,
});

export const cardAddError = (error) => ({
  type: CARDADD_ERROR,
  error,
});
export const unsubcriptionRequest = (payload) => ({
  type: UNSUBCRIPTION_REQUEST,
  ...payload,
});

export const unsubcriptionSuccess = (unsubcription) => ({
  type: UNSUBCRIPTION_SUCCESS,
});

export const unsubcriptionError = (error) => ({
  type: UNSUBCRIPTION_ERROR,
  error,
});

export const getPlanRequest = (payload) => {
  return {
    type: GET_PLAN_REQUEST,
    ...payload,
  };
};

export const getPlanSuccess = (plan) => {
  ({
    type: GET_PLAN_SUCCESS,
    plan,
  });
};

export const getPlanError = (error) => ({
  type: GET_PLAN_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/pages/subscription/actions.js